import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLightBulbSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="light-bulb-simple, idea"><path d="M3.99823 10.0009C3.99823 5.58212 7.58035 2 11.9991 2C16.4179 2 20 5.58212 20 10.0009C20 12.5861 18.7731 14.885 16.8729 16.3465C16.5959 16.5595 16.3045 16.7549 16.0003 16.9308V17H7.99793V16.9308C7.69377 16.7549 7.40234 16.5595 7.12534 16.3465C5.22513 14.885 3.99823 12.5861 3.99823 10.0009Z" fill="currentColor"/><path d="M7.99793 18.5V18.9988C7.99793 21.2086 9.78932 23 11.9991 23C14.2089 23 16.0003 21.2086 16.0003 18.9988V18.5H7.99793Z" fill="currentColor"/></CentralIconBase>;
};

export default IconLightBulbSimple;
